// Real pages from PIANO READY Volume 1 (WebP in Impultienda Recursos).
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ec175633-6df8-4ed9-ae67-c7c09deb78ea/1792725119830_pr-vol1-p01-cover-0b0bb198.webp',
  label: 'Volume 1 · Cover',
  title: 'Studio Year Plan & 12 Ready-to-Teach Lessons',
  text: 'Three tracks – Young Beginners, Older Beginners, Teens & Adults – with 30, 45 and 60-minute lessons, printable worksheets and tests with answer keys.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ec175633-6df8-4ed9-ae67-c7c09deb78ea/1792725123497_pr-vol1-p05-yearplan-4805b2ea.webp',
  label: 'Year plan · Page 5',
  title: '36-Week Plan · Young Beginners (5–8)',
  text: 'Week by week, from Meet the Keyboard to the studio recital – so you always know what comes next.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ec175633-6df8-4ed9-ae67-c7c09deb78ea/1792725126991_pr-vol1-p12-lesson1-13b1145f.webp',
  label: 'Lesson 1 · Page 12',
  title: 'Meet the Keyboard · 30 min',
  text: 'Young Beginners (5–8): goal, materials, a minute-by-minute plan and a word-for-word teacher script.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ec175633-6df8-4ed9-ae67-c7c09deb78ea/1792725130843_pr-vol1-p21-worksheet5-139f18a6.webp',
  label: 'Worksheet 5 · Page 21',
  title: 'Landmark Notes in 3 Levels',
  text: 'The same skill at three levels, so every student in your studio can work on it – at their own pace.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ec175633-6df8-4ed9-ae67-c7c09deb78ea/1792725134259_pr-vol1-p32-lesson11-a0c7182e.webp',
  label: 'Lesson 11 · Page 32',
  title: 'Petzold, Minuet in G in 4 Steps · 60 min',
  text: 'Teens & Adults: Look, Tap, Play, Polish – a public-domain piece taught step by step, with a teacher script.'
}];
